/**
 * @generated SignedSource<<00541b2b1934f8904571a059e3e76117>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DeliveryInfoDialogLazyContentQuery$variables = {
  deliveryId: string;
};
export type DeliveryInfoDialogLazyContentQuery$data = {
  readonly webhookDelivery: {
    readonly id: string;
    readonly payload: {
      readonly action: string;
      readonly data: string;
      readonly event: string;
    };
    readonly response: {
      readonly data: string;
      readonly duration: number;
      readonly status: number;
    };
    readonly timestamp: number;
  } | null;
};
export type DeliveryInfoDialogLazyContentQuery = {
  response: DeliveryInfoDialogLazyContentQuery$data;
  variables: DeliveryInfoDialogLazyContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deliveryId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "deliveryId"
      }
    ],
    "concreteType": "WebHookDelivery",
    "kind": "LinkedField",
    "name": "webhookDelivery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WebHookDeliveryPayload",
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "event",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "action",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WebHookDeliveryResponse",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryInfoDialogLazyContentQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryInfoDialogLazyContentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "df70970a7a6798ae4f5fd48b62f53719",
    "id": null,
    "metadata": {},
    "name": "DeliveryInfoDialogLazyContentQuery",
    "operationKind": "query",
    "text": "query DeliveryInfoDialogLazyContentQuery(\n  $deliveryId: String!\n) {\n  webhookDelivery(id: $deliveryId) {\n    id\n    timestamp\n    payload {\n      event\n      action\n      data\n    }\n    response {\n      status\n      duration\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aeafee9acd82ba92f46e25a396b0139";

export default node;
